import type { ReactElement } from 'react';
import { Popover, Tooltip } from '@heathmont/moon-core-tw';
import type Position from '@heathmont/moon-core-tw/lib/tooltip/private/types/Position';
import useAgentData from '~/client/hooks/useAgentData';
import useTournamentTooltip from './hooks/useTournamentTooltip';

type Props = {
  tooltipPosition?: Position;
  isCurrentTournaments?: boolean;
  trigger: ReactElement;
};

const TournamentTooltip: FC<Props> = ({
  tooltipPosition,
  isCurrentTournaments,
  children,
  trigger,
}) => {
  const { isMobile } = useAgentData();
  const { getTooltipPosition } = useTournamentTooltip();
  if (isMobile) {
    return (
      <Popover>
        <Popover.Trigger>{trigger}</Popover.Trigger>
        <Popover.Panel className="bg-popo/90 p-2 rem:min-w-[200px]">
          {children}
        </Popover.Panel>
      </Popover>
    );
  }
  return (
    <Tooltip>
      <Tooltip.Trigger>
        <span>{trigger}</span>
      </Tooltip.Trigger>
      <Tooltip.Content
        className="z-50 border-popo bg-popo/90 rem:min-w-[200px]"
        position={getTooltipPosition(tooltipPosition, isCurrentTournaments)}
      >
        {children}
        <Tooltip.Arrow className="bg-popo/90" />
      </Tooltip.Content>
    </Tooltip>
  );
};

export default TournamentTooltip;
